module.exports = __webpack_public_path__ + "static/media/live_icon3.4371070f.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/img/live_icon3.png
// module id = 175
// module chunks = 0